
import { combineReducers } from '@reduxjs/toolkit';
import { odabirVrsteQRReducer } from './stranice/odabir_vrste_qr';


const rootReducer = combineReducers({
    odabirVrsteQR:odabirVrsteQRReducer,
});

export default rootReducer;